import { Configuration } from '@happykit/flags/dist/config'

export const happykitConfig: Configuration<{}> = {
  envKey: process.env.NEXT_PUBLIC_FLAGS_ENV_KEY!,
}
